import React, { useState } from 'react';
// 2026 Men Getting Real Conference - Mobile Companion App v7

import { AnimatePresence, motion } from 'framer-motion';
import { BottomNav } from './components/BottomNav';
import { HomePage } from './pages/HomePage';
import { SchedulePage } from './pages/SchedulePage';
import { SessionsPage } from './pages/SessionsPage';
import { InfoPage } from './pages/InfoPage';
export function App() {
  const [activeTab, setActiveTab] = useState('home');
  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <HomePage setActiveTab={setActiveTab} data-id="element-0" />;
      case 'schedule':
        return <SchedulePage data-id="element-1" />;
      case 'sessions':
        return <SessionsPage data-id="element-2" />;
      case 'info':
        return <InfoPage data-id="element-3" />;
      default:
        return <HomePage setActiveTab={setActiveTab} data-id="element-4" />;
    }
  };
  return <div className="min-h-screen bg-gray-200 flex justify-center font-sans" data-id="element-5">
      {/* Mobile App Container */}
      <div className="w-full max-w-md bg-white min-h-screen relative shadow-2xl overflow-hidden flex flex-col" data-id="element-6">
        {/* Main Scrollable Content Area */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden scroll-smooth relative pb-20" data-id="element-7">
          <AnimatePresence mode="wait" data-id="element-8">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2,
            ease: 'easeInOut'
          }} className="min-h-full" data-id="element-9">
              {renderContent()}
            </motion.div>
          </AnimatePresence>
        </main>

        {/* Fixed Bottom Navigation */}
        <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-10" />
      </div>
    </div>;
}